import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"


const initialState = {
    data: null,
    loading: false,
    error: null,
    companyList: null,
    singlejob: null,
    response: null,
    applicants: null,
    applicantsLoading: false,


}

export const fetchAllCareerList = createAsyncThunk(
    "fetchAllCareerList",
    async (body) => {
        try {
            const response = await instance.get(`crm/career/fetch-all-career?page=${body.page}&search=${body.search}&company=${body?.company}`)
            return response.data;
        } catch (error) {
            return error?.response
        }
    }
)


export const fetchAllCompanyList = createAsyncThunk(
    "fetchAllCompanyList",
    async () => {
        try {
            const response = await instance.get("crm/career/fetch-all-comapny")
            return response.data;
        } catch (error) {
            return error?.response
        }
    }
)

export const fetchSingleJob = createAsyncThunk(
    "fetchSingleJob",
    async (id) => {
        try {
            const response = await instance.get(`crm/career/fetch-single-job?job_id=${id}`)
            return response.data;
        } catch (error) {
            return error?.response
        }
    }
)

export const addCareerJobList = createAsyncThunk("addCareerJobList", async (data) => {
    try {
        const response = await instance.post(`/crm/career/post-job`, data);
        return response?.data;
    } catch (error) {
        return error;
    }
})

export const fetchCareerApplicants = createAsyncThunk(
    "fetchCareerApplicants",
    async (filters) => {
        try {
            const params = new URLSearchParams({
                page: filters.page || 1,
                search: filters.search || "",
                company: filters.company || "",
                job_id: filters.job_id || "",
                start_date: filters.start_date || "",
                end_date: filters.end_date || "",
                sort_order: filters.sort_order || "DESC",
            });
            const response = await instance.get(`crm/career/fetch-applicants?${params.toString()}`);
            return response.data;
        } catch (error) {
            return error?.response?.data || { data: [], count: 0 };
        }
    }
)

export const CareerSlice = createSlice({
    name: "CareerSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAllCareerList.pending, (state) => {
            state.loading = true;
            state.data = null;
        });
        builder.addCase(fetchAllCareerList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchAllCareerList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
        builder.addCase(fetchAllCompanyList.pending, (state) => {
            state.loading = true;
            state.companyList = null;
        });
        builder.addCase(fetchAllCompanyList.fulfilled, (state, action) => {
            state.loading = false;
            state.companyList = action.payload;
        });
        builder.addCase(fetchAllCompanyList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.companyList;
        });
        builder.addCase(fetchSingleJob.pending, (state) => {
            state.loading = true;
            state.singlejob = null;
        });
        builder.addCase(fetchSingleJob.fulfilled, (state, action) => {
            state.loading = false;
            state.singlejob = action.payload;
        });
        builder.addCase(fetchSingleJob.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.singlejob;
        });
        builder.addCase(addCareerJobList.pending, (state) => {
            state.loading = true;
            state.response = null;
        });
        builder.addCase(addCareerJobList.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        });
        builder.addCase(addCareerJobList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.response;
        });
        builder.addCase(fetchCareerApplicants.pending, (state) => {
            state.applicantsLoading = true;
        });
        builder.addCase(fetchCareerApplicants.fulfilled, (state, action) => {
            state.applicantsLoading = false;
            state.applicants = action.payload;
        });
        builder.addCase(fetchCareerApplicants.rejected, (state, action) => {
            state.applicantsLoading = false;
            state.error = action.payload;
        });
    }
})

export default CareerSlice.reducer;
